import React from "react"
import { Link } from "react-router-dom"

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-12 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">GA</span>
              </div>
              <span className="font-bold text-white">GeneratorAutoStart</span>
            </div>
            <p className="text-sm">
              Expert solutions for generator automation, remote start systems, and solar backup power integration.
            </p>
          </div>

          {/* Solutions */}
          <div>
            <h3 className="font-semibold text-white mb-4">Solutions</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/solar-backup-power" className="hover:text-orange-500 transition-colors">
                  Solar Backup Power
                </Link>
              </li>
              <li>
                <Link to="/portable-generator" className="hover:text-orange-500 transition-colors">
                  Portable Generators
                </Link>
              </li>
              <li>
                <a href="#standby" className="hover:text-orange-500 transition-colors">
                  Standby Systems
                </a>
              </li>
            </ul>
          </div>

          {/* Brands */}
          <div>
            <h3 className="font-semibold text-white mb-4">Brands</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#honda" className="hover:text-orange-500 transition-colors">Honda</a></li>
              <li><a href="#onan" className="hover:text-orange-500 transition-colors">Onan</a></li>
              <li><a href="#generac" className="hover:text-orange-500 transition-colors">Generac</a></li>
              <li><a href="#briggs" className="hover:text-orange-500 transition-colors">Briggs & Stratton</a></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-semibold text-white mb-4">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/guides" className="hover:text-orange-500 transition-colors">
                  Installation Guides
                </Link>
              </li>
              <li>
                <a href="#troubleshooting" className="hover:text-orange-500 transition-colors">
                  Troubleshooting
                </a>
              </li>
              <li>
                <a href="#faq" className="hover:text-orange-500 transition-colors">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-sm text-center">
          <p>&copy; {new Date().getFullYear()} GeneratorAutoStart.com - All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
